import { Box, darken, styled } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { dragActionActiveAtom } from '../../atoms';
import { brightness } from 'utils/misc';
import { DARK, RED, WHITE } from 'constants/colors';
import { getActivityTypeColor } from '../../utils';
import { ZoomLevel as DetailZoomLevel } from '../../components/Header/ZoomLevelMenu';
import { CHIP_CLASS_NAME } from './Chip.constants';
import { BaseChip } from './Chip.styles';

const StyledChip = styled(BaseChip, {
  shouldForwardProp: (p) =>
    !['width', 'selected', 'hasWarnings'].includes(p as string)
})(
  ({
    width,
    selected,
    hasWarnings
  }: {
    width: number;
    selected: boolean;
    hasWarnings: boolean;
  }) => ({
    width: `${width}px`,
    backgroundColor: hasWarnings ? brightness(RED, 90) : WHITE,
    ...(selected && { boxShadow: `0px 0px 0px 2px ${DARK}` }),
    '&:hover': {
      cursor: 'grab',
      backgroundColor: darken(hasWarnings ? brightness(RED, 90) : WHITE, 0.02),
      transitionDuration: '150ms'
    }
  })
);

export const Chip = ({
  children,
  width,
  isClient,
  isRecurring,
  isAbsent,
  selected,
  hasWarnings,
  handleRightClick,
  detailZoomLevel
}: {
  children: React.ReactNode;
  width: number;
  isClient: boolean;
  isRecurring?: boolean;
  isAbsent: boolean;
  selected: boolean;
  hasWarnings: boolean;
  handleRightClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  detailZoomLevel?: number;
}) => {
  const dragActionActive = useRecoilValue(dragActionActiveAtom);

  return (
    <StyledChip
      className={CHIP_CLASS_NAME}
      width={width}
      height={detailZoomLevel === DetailZoomLevel.COMPACT ? '20px' : '40px'}
      selected={selected}
      hasWarnings={hasWarnings}
      onContextMenu={handleRightClick}
      sx={{
        '&:hover': {
          ...(!dragActionActive &&
            !selected && {
              boxShadow: `0px 0px 5px rgba(0, 0, 0, 0.25)`
            })
        }
      }}
    >
      <Box
        sx={{
          height: '100%',
          minWidth: isRecurring ? '4px' : '2px',
          backgroundColor: getActivityTypeColor(isClient, isAbsent),
          mr: '4px'
        }}
      />
      {children}
    </StyledChip>
  );
};
